import React from "react";
import { Box, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const AZUL_GRAF = "#1976d2";

const itemBase = {
  display: "flex",
  gap: 10,
  alignItems: "flex-start",
  padding: "10px 12px",
  borderRadius: 10,
  background: "#ffffff",
  boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
  borderLeft: `3px solid ${AZUL_GRAF}`,
};

const RecomendacionesTendencias = ({ desemp, cuc, correo }) => {
  if (!correo || !String(correo).includes("@")) {
    return (
      <Box mt={1}>
        <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 800, color: "#0f172a" }}>
          Recomendaciones
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Escribe un correo válido para cargar las alertas de predicción.
        </Typography>
      </Box>
    );
  }

  const items = [];
  if (desemp && String(desemp).trim()) {
    items.push({ key: "desemp", text: desemp });
  }
  if (cuc && String(cuc).trim()) {
    items.push({ key: "cuc", text: cuc });
  }

  if (!items.length) {
    return (
      <Box mt={1}>
        <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 800, color: "#0f172a" }}>
          Recomendaciones
        </Typography>
        <Typography variant="body2" color="textSecondary">
          No hay recomendaciones para este correo. Verifica que existan registros en predicción / alertas.
        </Typography>
      </Box>
    );
  }

  return (
    <Box mt={1}>
      <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 800, color: "#0f172a" }}>
        Recomendaciones
      </Typography>
      <Box display="flex" flexDirection="column" style={{ gap: 12 }}>
        {items.map((it) => (
          <Box key={it.key} style={itemBase}>
            <InfoOutlinedIcon style={{ color: AZUL_GRAF, fontSize: 22, flexShrink: 0, marginTop: 1 }} />
            <Typography variant="body2" style={{ color: "#1e293b", lineHeight: 1.45 }}>
              {it.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RecomendacionesTendencias;
